// Backend route-state codes.
export const VEHICLE_STATES = [
  { state: 0, key: "vehicle_counter_stopped", className: "border-slate-300 bg-slate-100 text-slate-600" },
  { state: 2, key: "vehicle_counter_idle", className: "border-amber-300 bg-amber-100 text-amber-700" },
  { state: 1, key: "vehicle_counter_moving", className: "border-emerald-300 bg-emerald-100 text-emerald-700" },
  { state: 3, key: "vehicle_counter_no_data", className: "border-slate-300 bg-slate-100 text-slate-600" },
] as const;
